export default (fields, { prefix, ...rest }) => {
  return fields.map((obj) => ({
    ...rest,
    ...obj,
    key: `${prefix}-${obj.key}`,
  }));
};
